export const api_url = window.location.hostname.includes("ascension")
  ? "https://buyapi.ascensionapp.com"
  : "http://localhost:3000";

export const stripe_public_key = window.location.hostname.includes("ascension")
  ? "pk_live_NujMUBZxIou8dURLKdRZzYdA"
  : "pk_test_ig2xmSba77udYIpObhkcrQc7";
